import { render } from "./billPayments.vue?vue&type=template&id=1c52a760"
import script from "./billPayments.vue?vue&type=script&lang=js"
export * from "./billPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__